"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgScript(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm15.49 1.711a8.2739 8.2739 0 0 1 .51 2.27569h-1.352c.23124-2.44606.842-2.27569.842-2.27569zm-6.36506 10.30083a3.101 3.101 0 0 0 1.8622 2.98817h-9.49736c-1.07072 0-1.48978-2.98817-1.48978-2.98817zm.99872-1.00135v1.00133a2.0961 2.0961 0 0 0 1.20188 2.046l.6804.24569a4.23265 4.23265 0 0 0 .46729-1.53775c.36135-2.56792 1.26467-9.52473 1.26467-9.52473s.13551-2.19439 1.26479-2.24102h-9.937s-1.17427.04663-1.44534 1.86759c-.15835 1.06428-.68689 5.02981-1.09889 8.14289z', fillRule: 'evenodd' })));
}
exports.default = SvgScript;
